module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "backdrop": false,
      "width": _vm.localWidth,
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [(_vm.textTitle && _vm.textTitle.length > 0) ? _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    style: (_vm.titleStyle)
  }, [_c('strong', [_vm._v(_vm._s(_vm.textTitle))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    style: ('Width: ' + _vm.model_height + 'px;padding: 5px 15px; '),
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer no_focus",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.textNo.length > 0) ? _c('button', {
    class: 'btn btn-default ' + _vm.no_color,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v(_vm._s(_vm.textNo))]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.textYes.length > 0),
      expression: "textYes.length > 0"
    }],
    class: 'confirmation-modal-footer-yes-btn btn btn-' + _vm.yes_color,
    attrs: {
      "type": "button",
      "data-cy": 'confirmation-modal-footer-yes-btn' + _vm.textTitle,
      "id": "confirmationModalYes"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a88844","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/confirmation-modal.vue
// module id = 989
// module chunks = 0